const { Marker } =
    typeof window !== "undefined" ? require("react-leaflet") : {};

// For some reasons this trivial example doesn't work.
// export const PlaceMarker = (...props) => <Marker {...props} />;

export const PlaceMarker = Marker;
export default PlaceMarker;
